import React, { Component } from 'react';
import { Redirect } from "react-router-dom"
import { Modal, Button } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class SectionWidgetDeleteConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transPage: "modals.widget_delete."
        }

        this.deleteSelectedWidget = this.deleteSelectedWidget.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
        // this.onHideModal = this.onHideModal.bind(this)
    }

    deleteSelectedWidget() {
        // dari props method nya
        this.props.deleteSelectedWidget() 
    }

    onOpenModal() {
        //console.log("modal open")
    }

    
    render() {
        const {t} = this.props;
        const listWidgetName = this.props.selectedWidget.map(item => {
            return (<li key={item.id}>{ item.name }</li>)
        })

        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide()} onShow={() => this.onOpenModal()}>
                {this.props.loadingModal}
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>{t(this.state.transPage + "title")} </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p> {t(this.state.transPage + "confirmation_text")}</p>
                    <ul>
                        {listWidgetName}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.onHide()}>
                        {t('cancel')}
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteSelectedWidget()}>
                        <i className="fa fa-trash">&nbsp;</i>
                        {t(this.state.transPage + "delete_widget")}
                    </Button>   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(SectionWidgetDeleteConfirm);